import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";

import {Messages} from "../../../../Messages";
import {DEFAULT_DATE_FORMAT} from "../../../../Constants";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";


class SubscriptionOverviewStyle extends StyleSheet {
    @styleRule
    activeSubscriptionInfo = {
        paddingTop: 6,
        textAlign: "center",
        whiteSpace: "nowrap",
    };

    @styleRule
    boldInfo = {
        fontWeight: "bold",
        color: this.themeProps.MERCHANT_ACTIVE_SUBSCRIPTION_TITLE,
    };

    @styleRule
    priceInfo = {
        color: this.themeProps.MERCHANT_ACTIVE_SUBSCRIPTION_PRICE,
        display: "inline-block",
        marginLeft: 5,
    };
}

@registerStyle(SubscriptionOverviewStyle)
export class SubscriptionOverview extends UI.Element {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.activeSubscriptionInfo);
    }

    render() {
        const {styleSheet} = this;
        const {subscription} = this.options;
        const offer = subscription.getOffer();

        const paidUntil = subscription.getPaidUntil();
        const nextBillingDate = subscription.getNextBillingDate();

        return subscription.isActiveButCanceled() ? [
            <div className={styleSheet.boldInfo}>{Messages.canceledSubscription}</div>,
            <div>
                <span className={styleSheet.boldInfo}>{offer.getCoverageName()}</span>
                <span className={styleSheet.priceInfo}>
                    ({Messages.canceled})
                </span>
            </div>,
            paidUntil ? <div>{Messages.expiresOnDate(paidUntil.format(DEFAULT_DATE_FORMAT))}</div> : null
        ] : [
            <div className={styleSheet.boldInfo}>{Messages.activeSubscription}</div>,
            <div>
                <span className={styleSheet.boldInfo}>{offer.getCoverageName()}</span>
            </div>,
            nextBillingDate ? <div>{Messages.nextBillingDate(nextBillingDate.format(DEFAULT_DATE_FORMAT))}</div> : null
        ];
    }
}
